import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface SsoCallbackProps {
  onLogin: (user?: any) => void;
}

const SsoCallback: React.FC<SsoCallbackProps> = ({ onLogin }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');

    if (!token) {
      navigate('/login', { replace: true });
      return;
    }

    const payload = JSON.parse(atob(token.split('.')[1]));
    const user = {
      id: payload.userId,
      email: payload.email,
      name: payload.name,
      role: payload.role,
    };

    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('isAuthenticated', 'true');

    onLogin();
    navigate('/dashboard', { replace: true });
  }, []);

  return <div style={{ padding: 40, textAlign: 'center' }}>Signing you in…</div>;
};

export default SsoCallback;